export default __webpack_public_path__ + "static/sizzle_desktop-54eb88d093b4dfaccbf385de4499e512.mp4";